/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  BannerComponent.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H224423
*
* @Date			: Mar 12, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Mar 12, 2019
* Description   : Added Modification History. Updated Verbiage.
*
* By            : H224423
* On            : Mar 12, 2019
* Description   : Reverted Verbiage changes
*
*******************************************************************/
import * as React from 'react';
import { Grid } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './bannerComponent.css';


function BannerComponent() {
    return (
        <React.Fragment>
            <Grid className="fullwidthRow ">
                <Grid.Row className="fullwidthRow ">
                    <Grid.Column width={12} className="fullwidthRow ">
                        <div className="item-detail img-full-width" id="banner_item_detail">
                            <div className="image col-md-12">
                                <h1 className="col-md-12  col-lg-10">Purchase software</h1>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </React.Fragment>
    );
}

export default BannerComponent;